import { render, staticRenderFns } from "./ConfirmDeleteQuote.vue?vue&type=template&id=2b043a1a&scoped=true"
import script from "./ConfirmDeleteQuote.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteQuote.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteQuote.vue?vue&type=style&index=0&id=2b043a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b043a1a",
  null
  
)

export default component.exports